import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  CardContent,
  Chip,
  Zoom,
  Fade,
  Grow,
  alpha,
} from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const GradientText = styled("span")(({ theme }) => ({
  background: "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "inherit",
  backgroundSize: "200% 200%",
  animation: `${shimmer} 3s ease-in-out infinite`,
}));

const Features = () => {
  const features = [
    // {
    //   icon: "🛒",
    //   // title: "Live Product Catalog",
    //   title: "Dealer & Distribution App",
    //   description:
    //     // "Update prices once, all dealers see it instantly. No more outdated Excel sheets or wrong quotes.",
    //     "Give your dealers a 24/7 mobile ordering platform with real-time tracking, credit control, and live catalog — no WhatsApp chaos."
    // },
    {
      icon: "⚡",
      title: "E-Commerce Solutions",
      description: "Custom online stores & B2B portals, Secure, scalable & mobile-friendly eCommerce platforms, B2B, B2C with advanced customization.",
    },
    {
      icon: "🏗️",
      // title: "30-Second Ordering",
      title: "ERP Solutions",
      description:
        // "Dealers add to cart and order in seconds. No phone calls, no WhatsApp, no confusion.",
        "Custom-built or integrated ERP systems designed around your operations — inventory, finance, orders, and reporting in one place."
    },
    {
      icon: "💻",
      // title: "Auto Interest on Overdue",
      title: "Custom Software Development",
      description:
        // "System calculates interest automatically. Dealers see exactly what they owe, when it's due.",
        "Web apps, mobile apps, APIs, and dashboards — built from scratch to solve your exact business problem, not a generic one."
    },
    // {
    //   icon: "📊",
    //   title: "Real-Time Analytics",
    //   description:
    //     "See which dealers are ordering, which products are moving, and where your revenue is coming from.",
    // },
    // {
    //   icon: "🔔",
    //   title: "Smart Reminders",
    //   description:
    //     "Automatic payment reminders via app, SMS, and WhatsApp. Get paid faster without chasing.",
    // },
    // {
    //   icon: "🎯",
    //   title: "Credit Control",
    //   description:
    //     "Set credit limits per dealer. System blocks orders when limit is reached. Zero defaults.",
    // },
  ];

  return (
    <Box
      id="features"
      sx={{ py: { xs: 5, sm: 7, md: 10, lg: 16 }, bgcolor: "white" }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            textAlign: "center",
            mb: { xs: 4, md: 8 },
            maxWidth: "800px",
            mx: "auto",
            px: { xs: 2, sm: 0 },
          }}
        >
          <Grow in timeout={800}>
            <Chip
              // icon={<RocketLaunch />}
              // label="POWERFUL FEATURES"
              label="What We Build"
              sx={{
                bgcolor: alpha("#2E9E53", 0.1),
                color: "#2E9E53",
                fontWeight: 800,
                mb: 3,
                px: 3,
                py: 2.5,
                fontSize: "0.9rem",
                border: `1px solid ${alpha("#2E9E53", 0.3)}`,
                "& .MuiChip-icon": { color: "#2E9E53" },
              }}
            />
          </Grow>
          <Zoom in timeout={1000}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 900,
                color: "#0B4064",
                fontFamily: "'Archivo Black', sans-serif",
                fontSize: {
                  xs: "1.8rem",
                  sm: "2.2rem",
                  md: "3rem",
                  lg: "3.5rem",
                },
                lineHeight: 1.2,
                mb: { xs: 1.5, md: 2 },
              }}
            >
              {/* Everything Your <GradientText>Dealers</GradientText> Need in One
              App */}
              Everything Your Business Needs, Built by
              <GradientText> One Team </GradientText>
            </Typography>
          </Zoom>

          <Fade in timeout={1500}>
            <Typography
              variant="h5"
              sx={{
                color: "#2D3142",
                maxWidth: "800px",
                mx: "auto",
                mb: 4,
                lineHeight: 1.8,
                fontSize: { xs: "1.1rem", md: "1.3rem" },
              }}
            >
              {/* From live pricing to payment tracking, give your dealers the tools
              to order faster and pay on time. All in one powerful platform. */}
              From day-one deployment to long-term scaling, BizBridge delivers technology that fits exactly how your business operates.
            </Typography>
          </Fade>
        </Box>

        <Grid container spacing={{ xs: 2, sm: 3, md: 3, lg: 4 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} lg={4} key={index} sx={{ gap: "2.5rem" }}>
              <Box sx={{ height: "100%" }}>
                <Box
                  sx={{
                    mr: 2,
                    ml: 2,
                    mb: 4,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    bgcolor: "rgb(247, 247, 247)",
                    borderRadius: { xs: "15px", md: "20px" },
                    border: "2px solid transparent",
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "3px",
                      background: "linear-gradient(90deg, #0B4064, #2e9e53)",
                      transform: "scaleX(0)",
                      transition: "transform 0.3s",
                    },
                    "&:hover::before": {
                      transform: "scaleX(1)",
                    },
                    "&:hover": {
                      borderColor: "#0B4064",
                      transform: "translateY(-5px)",
                      boxShadow: "0 15px 40px rgba(11, 64, 100, 0.2)",
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      // p: { xs: 4, sm: 4.5, md: 6 },
                      "&:last-child": { pb: { xs: 2, sm: 2.5, md: 3 } },
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: "55px", sm: "60px", md: "70px" },
                        height: { xs: "55px", sm: "60px", md: "70px" },
                        bgcolor: "#2e9e53",
                        borderRadius: { xs: "12px", md: "15px" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: { xs: "1.6rem", sm: "1.8rem", md: "2rem" },
                        mb: { xs: 1.5, md: 2 },
                        transform: "rotate(-5deg)",
                      }}
                    >
                      {feature.icon}
                    </Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontFamily: "'Archivo Black', sans-serif",
                        fontSize: { xs: "1.15rem", sm: "1.3rem", md: "1.5rem" },
                        mb: { xs: 0.8, md: 1 },
                        color: "#0B4064",
                        lineHeight: 1.3,
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
                        lineHeight: 1.6,
                        fontFamily: "'DM Sans', sans-serif",

                        color: "#2D3142",
                        opacity: 0.8,
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Features;
